import React from 'react';

import ODAPriceFields, { ODAFormFooter } from '../../ODA/ODAPriceFields';
import ODAPriceLevels from '../../ODA/ODAPriceLevels';
import useODAForm from '../../ODA/useODAForm';

type Props = {
  id: number;
  onComplete: () => void;
  tradingBlocked: boolean;
};

const ODAForm: React.FC<Props> = ({ id, onComplete, tradingBlocked }) => {
  const form = useODAForm(id, onComplete, tradingBlocked);

  return (
    <div className="markets-v3-form markets-v3-oda-form">
      <div className="markets-v3-form__body">
        <div className="markets-v3-form__intro">
          Protect <strong>{form.name}</strong> with linked stop-loss and
          take-profit orders.
        </div>
        <div className="oda-layout oda-layout--below">
          <ODAPriceFields form={form} />
          <ODAPriceLevels form={form} />
        </div>
      </div>
      <div className="markets-v3-form__footer">
        <ODAFormFooter form={form} />
      </div>
    </div>
  );
};

export default ODAForm;
